import { createFileRoute } from '@tanstack/react-router';
import { RevenuePurposeRouteComponent } from '@/app/route-components/settlement-statistics-converter/RevenuePurposeRouteComponent';
import { requireReleaseFlag } from '@/entities/session/lib/releaseGuard';

/**
 * 決算統計コンバーター結果詳細ルート（マスタ - 歳入区分）
 */
export const Route = createFileRoute(
  '/_protected/settlement-statistics-converter/$resultId/master/revenue_purpose',
)({
  component: RevenuePurposeRouteComponent,
  beforeLoad: () => {
    requireReleaseFlag('settlement_statistics_converter');
  },
});
